var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Portfolio as PortfolioModel } from '@/models/Portfolio';
import { chunk, cloneDeep, findIndex, slice } from 'lodash';
import UploadFileDialog from '@/views/Users/Student/Progress/UploadFileDialog';
import PhotoAlbumCarouselDialog from '@/views/Users/Student/Progress/PhotoAlbumCarouselDialog';
import ErrorHandler from '@/support/ErrorHandler';
import ImageInput from '@/components/dialog/image-input/ImageInput';
let ProgressAlbum = class ProgressAlbum extends Vue {
    constructor() {
        super(...arguments);
        this.portfolioClone = null;
        this.files = [];
        this.filesToDelete = [];
        this.bigSizeFiles = [];
        this.smallSizeFiles = [];
        this.photoAlbumFiles = [];
        this.changeSelectedFile = null;
        this.isEditingPhotoAlbum = false;
        this.isUpdatingPhotoAlbum = false;
        this.isUploadingPhotoInAlbum = false;
        this.isOpeningCarouselDialog = false;
        this.isChangingAvatar = false;
        this.isLoadingCanvas = false;
        this.baseImage = null;
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.portfolioClone = cloneDeep(this.portfolio);
        this.files = this.portfolioClone.files;
        this.chunkFiles();
    }
    chunkFiles() {
        if (!this.files.length) {
            this.bigSizeFiles = [];
            this.smallSizeFiles = [];
            return;
        }
        this.photoAlbumFiles = this.files.filter((file) => {
            return file.collection === 'photo-album';
        });
        this.bigSizeFiles = chunk(this.photoAlbumFiles, 2)[0];
        this.smallSizeFiles = slice(this.photoAlbumFiles, 2);
    }
    deletePhotoFromAlbum(deletedFile) {
        this.files = this.files.filter((file) => {
            return file.id !== deletedFile.id;
        });
        this.filesToDelete.push(deletedFile);
        this.chunkFiles();
    }
    async updatePhotoAlbum() {
        const filesToDelete = this.filesToDelete.map(async (file) => {
            return new PortfolioModel()
                .deleteFileFromPortfolio(this.portfolio.id, file.id);
        });
        const response = await Promise
            .allSettled(filesToDelete)
            .catch(ErrorHandler.network);
        if (response) {
            this.$emit('portfolioUpdated');
            this.filesToDelete = [];
        }
    }
    resetPhotoAlbum() {
        this.filesToDelete = [];
        this.files = cloneDeep(this.portfolio).files;
        this.chunkFiles();
        this.isEditingPhotoAlbum = false;
    }
    fileUploaded() {
        this.$emit('portfolioUpdated');
    }
    openCarouselDialog(selectedFile) {
        const fileIndex = findIndex(this.photoAlbumFiles, (file) => {
            return file.id == selectedFile.id;
        });
        if (fileIndex === 0) {
            this.isOpeningCarouselDialog = true;
            return;
        }
        this.photoAlbumFiles = [...chunk(this.photoAlbumFiles, fileIndex)[1], ...chunk(this.photoAlbumFiles, fileIndex)[0]];
        this.isOpeningCarouselDialog = true;
    }
    async changingCurrentPhoto(file) {
        this.isLoadingCanvas = true;
        this.changeSelectedFile = file;
        const portfolioWithDataObjects = await new PortfolioModel()
            .include(['files', 'data_objects'])
            .find(this.portfolio.id);
        if (portfolioWithDataObjects) {
            const dataObject = portfolioWithDataObjects.files.find((obj) => obj.id === file.id);
            this.baseImage = dataObject ? dataObject.data_objects.file : '';
            this.isChangingAvatar = true;
            this.isLoadingCanvas = false;
        }
    }
    photoChanged(imageUrl) {
        if (!this.changeSelectedFile) {
            return;
        }
        new PortfolioModel()
            .deleteFileFromPortfolio(this.portfolio.id, this.changeSelectedFile.id)
            .then(() => {
            //
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        const payload = {
            file_base64: imageUrl,
            collection: 'photo-album',
            description: this.changeSelectedFile.description,
        };
        new PortfolioModel()
            .uploadFileInPortfolio(this.portfolio.id, payload)
            .then(() => {
            this.$emit('portfolioUpdated');
            this.isChangingAvatar = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get isTablet() {
        const userAgent = navigator.userAgent.toLowerCase();
        return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    }
    get user() {
        return this.$store.state.Auth;
    }
    get dialogOptions() {
        return {
            title: this.$t('progress.dialog.title').toString(),
            text: this.$t('progress.dialog.subtitle', { item: this.$tc('progress.photoalbum.title', 2) }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: async () => {
                        await this.updatePhotoAlbum();
                        this.isEditingPhotoAlbum = false;
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.isUpdatingPhotoAlbum = false;
                    },
                },
            },
        };
    }
    onPortfolioUpdate(newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        this.initialize();
    }
};
__decorate([
    Prop({ default: {} }),
    __metadata("design:type", typeof (_a = typeof PortfolioModel !== "undefined" && PortfolioModel) === "function" ? _a : Object)
], ProgressAlbum.prototype, "portfolio", void 0);
__decorate([
    Watch('portfolio'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof PortfolioModel !== "undefined" && PortfolioModel) === "function" ? _b : Object, typeof (_c = typeof PortfolioModel !== "undefined" && PortfolioModel) === "function" ? _c : Object]),
    __metadata("design:returntype", void 0)
], ProgressAlbum.prototype, "onPortfolioUpdate", null);
ProgressAlbum = __decorate([
    Component({
        components: {
            'upload-file-dialog': UploadFileDialog,
            'photo-album-carousel-dialog': PhotoAlbumCarouselDialog,
            'image-input': ImageInput,
        },
    })
], ProgressAlbum);
export default ProgressAlbum;
